import { Shape } from './Shape';

export { Shape };
